import { OnboardingStageWorkflowItem } from "@/pages/settings/components/contractsSettings/types";
import { CheckboxWithTextValue, OnboardingWorkflowResponseValue, WorkflowScoreStatus } from "./types";

export const isAnswered = (value: OnboardingWorkflowResponseValue): boolean => {
  if (value === undefined || value === null) return false;
  if (typeof value === "boolean") return true;
  if (typeof value === "number") return true;
  if (typeof value === "string") return value.trim().length > 0;
  if (Array.isArray(value)) return value.length > 0;
  if (typeof value === "object" && "checked" in value)
    return Boolean((value as CheckboxWithTextValue).checked);
  if (typeof value === "object" && "fromDate" in value)
    return Boolean(value.fromDate);
  return false;
};

export const resolveWorkflowScoreStatus = (
  items: OnboardingStageWorkflowItem[],
  responses: Record<string, OnboardingWorkflowResponseValue>,
  serverStatus: number | null
): number | null => {
  if (serverStatus === WorkflowScoreStatus.COMPLETED) return serverStatus;
  const requiredItems = items.filter((item) => item.isGuardrails);
  const requiredComplete =
    requiredItems.length > 0 &&
    requiredItems.every((item) => isAnswered(responses[item.id]));
  return requiredComplete ? WorkflowScoreStatus.REQUIRED_COMPLETED : serverStatus;
};
